import { envVars } from '../../helpers';

export const GOOGLE_ANALYTICS_ID = envVars(
  'NEXT_PUBLIC_GOOGLE_ANALYTICS_ID',
  process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID
).asString();
